import { render, staticRenderFns } from "./modalAddEditorials.vue?vue&type=template&id=7158db17&"
import script from "./modalAddEditorials.vue?vue&type=script&lang=js&"
export * from "./modalAddEditorials.vue?vue&type=script&lang=js&"
import style0 from "./modalAddEditorials.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports